<!-- Скрываемая секция дополнительных адресных данных точки маршрута для ЭДО -->
<template>
  <BaseFormSection
    class="route-point-address-details"
    title="Детали адреса"
    info="Используются для заполнения ЭДО"
    columns="2"
    title-size="14px"
    collapsible
    :initially-expanded="false"
    :summary="summary"
  >
    <BaseFormField
      label="Город"
      for-id="city"
      :filled="Boolean(point.city)"
      info-key="routePoint.common"
    >
      <base-input
        id="city"
        :model-value="point.city"
        @update:modelValue="updateField('city', $event)"
      />
    </BaseFormField>

    <BaseFormField
      label="Улица"
      for-id="street"
      :filled="Boolean(point.street)"
      info-key="routePoint.common"
    >
      <base-input
        id="street"
        :model-value="point.street"
        @update:modelValue="updateField('street', $event)"
      />
    </BaseFormField>

    <BaseFormField
      label="Дом"
      for-id="house"
      :filled="Boolean(point.house)"
      info-key="routePoint.common"
    >
      <base-input
        id="house"
        :model-value="point.house"
        @update:modelValue="updateField('house', $event)"
      />
    </BaseFormField>

    <BaseFormField
      label="Индекс"
      for-id="postal_code"
      :filled="Boolean(point.postal_code)"
      info-key="routePoint.common"
    >
      <base-input
        id="postal_code"
        :model-value="point.postal_code"
        @update:modelValue="updateField('postal_code', $event)"
      />
    </BaseFormField>

    <BaseFormField
      label="Код региона"
      for-id="region_code"
      :filled="Boolean(point.region_code)"
      info-key="routePoint.common"
      wide
    >
      <base-input
        id="region_code"
        :model-value="point.region_code"
        @update:modelValue="updateField('region_code', $event)"
      />
    </BaseFormField>
  </BaseFormSection>
</template>

<script>
export default {
  name: "RoutePointAddressDetailsSection",

  props: {
    point: {
      type: Object,
      required: true,
    },
  },

  emits: ["update-field"],

  computed: {
    summary() {
      const location = [
        this.point.city,
        this.point.street,
        this.point.house,
      ].filter(Boolean);

      const serviceData = [
        this.point.postal_code ? `индекс ${this.point.postal_code}` : "",
        this.point.region_code ? `регион ${this.point.region_code}` : "",
      ].filter(Boolean);

      if (location.length || serviceData.length) {
        return [...location, ...serviceData].join(" · ");
      }

      return "Город, улица, дом, индекс и регион";
    },
  },

  methods: {
    updateField(field, value) {
      this.$emit("update-field", field, value);
    },
  },
};
</script>

<style scoped>
.route-point-address-details.route-point-address-details {
  margin-top: 12px;
  padding: 0 0 0 10px;
  border-left: 2px solid #e4e7ec;
}

.route-point-address-details :deep(.form-layout__header) {
  margin-bottom: 3px;
}

.route-point-address-details :deep(.form-layout__title) {
  color: #475467;
  font-weight: 500;
}

.route-point-address-details :deep(.form-layout__summary) {
  color: #667085;
  font-size: 12px;
  line-height: 16px;
}

.route-point-address-details :deep(.form-layout__row) {
  padding-top: 8px;
  gap: 10px 12px;
}
</style>
